import React from 'react'
import { useRouter } from 'next/router'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'
import { useToast } from '@wartek-id/toast'

import { useAPIAjukanPerencanaan } from 'api/kinerja/pengawas-sekolah/perencanaan'
import { Card, CardBody } from 'app/KinerjaShared/components/Card'
import { Header } from 'app/KinerjaShared/components/Header'
import { PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import { DialogSendConfirmation } from 'app/KinerjaPSPegawaiPage/components/DialogSendConfirmation'
import { FooterActionV2 } from 'app/KinerjaPSPegawaiPage/components/FooterActionV2'
import { SectionPraktikKinerja } from 'app/KinerjaPSPegawaiPage/pages/Perencanaan/Ajukan/SectionPraktikKinerja'
import { SectionPengembanganKompetensi } from 'app/KinerjaPSPegawaiPage/pages/Perencanaan/Ajukan/SectionPengembanganKompetensi'
import { SectionPerilakuKerja } from 'app/KinerjaPSPegawaiPage/pages/Perencanaan/Ajukan/SectionPerilakuKerja'
import { SUMMARY_HINTS } from 'app/KinerjaPSPegawaiPage/constants/kirim'
import { usePerencanaanPS } from 'app/KinerjaPSPegawaiPage/hooks/usePerencanaan'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { useStoreByUserId } from 'app/KinerjaPSPegawaiPage/hooks/useStoreByUserId'
import { SectionPelaksanaanTugas } from 'app/KinerjaPSPegawaiPage/pages/Perencanaan/Ajukan/SectionPelaksanaanTugas'
import { usePPSTrackEvent } from 'app/KinerjaPSPegawaiPage/hooks/usePPSTrackEvent'

type AjukanProps = {}
const Ajukan: React.FC<AjukanProps> = ({}) => {
  const router = useRouter()
  const toast = useToast()
  const { period } = usePeriodContext()
  const { trackEvent } = usePPSTrackEvent()

  const [isDialogSendConfirmationOpen, setDialogSendConfirmationOpen] =
    React.useState<boolean>(false)

  // API Submit Perencaanan form
  const { isLoading: isSubmitting, mutateAsync } = useAPIAjukanPerencanaan(
    period.id
  )

  // Summary
  const { perencanaan } = usePerencanaanPS()

  // set Store by User ID
  useStoreByUserId()

  const submit = async () => {
    try {
      await mutateAsync({})

      // Track Submission
      trackEvent('perencanaan pegawai', 'submit perencanaan')

      // Close dialog
      setDialogSendConfirmationOpen(false)

      // Display toast
      toast({
        message: 'Berhasil ajukan Perencanaan!',
        type: 'success',
      })

      // Redirect to Beranda
      setTimeout(() => {
        router.push(
          `${PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH}/perencanaan/beranda`
        )
      }, 500)
    } catch (e) {
      setDialogSendConfirmationOpen(false)
      toast({
        message: 'Gagal ajukan Perencanaan. Coba lagi.',
      })
    }
  }

  return (
    <div className="pb-20">
      <Header title="Pengajuan Perencanaan" className="mb-9 print:hidden" />

      <div className="grid grid-cols-12 gap-x-6">
        <div className="col-span-3">
          <Card className="sticky bg-white border rounded-md border-subdued top-24">
            <CardBody className="p-6 space-y-6">
              <Text variant="heading-sm" className="flex-1">
                Pastikan:
              </Text>
              <div className="space-y-4 text-left">
                {SUMMARY_HINTS.map((hint, index) => (
                  <div key={index} className="flex space-x-3">
                    <Icon>check_circle_outlined</Icon>
                    <div className="space-y-1">
                      <Text>{hint}</Text>
                    </div>
                  </div>
                ))}
              </div>
            </CardBody>
          </Card>
        </div>

        <div className="col-span-9 space-y-10">
          {/* Praktik Kinerja */}
          <SectionPraktikKinerja data={perencanaan} showRightAction />

          {/* Perilaku Kerja */}
          <SectionPerilakuKerja data={perencanaan} showRightAction />

          {/* Pengembangan Kompetensi */}
          <SectionPengembanganKompetensi data={perencanaan} showRightAction />

          {/* Pelaksanaan Tugas */}
          <SectionPelaksanaanTugas />
        </div>
      </div>

      <FooterActionV2
        isNextDisabled={isSubmitting}
        nextLabel="Ajukan Perencanaan"
        onNext={() => setDialogSendConfirmationOpen(true)}
      />

      <DialogSendConfirmation
        isOpen={isDialogSendConfirmationOpen}
        onClose={() => setDialogSendConfirmationOpen(false)}
        onConfirm={submit}
      />
    </div>
  )
}
export default Ajukan
